import * as L from "leaflet";
import axios from "axios";

import React from "react";
import { renderToString } from "react-dom/server";
import store from "../../../../store";
import { UPDATE_CREATE_PARAMS } from "../../../actions/types";
import hist from "../../../../hist";

L.TileLayer.BetterWMS = L.TileLayer.WMS.extend({
  initialize: function (
    url,
    options,
    popupMapping,
    featureResolution = 0.0001
  ) {
    this.CQL_FILTER = undefined;
    this.popup = undefined;
    this.popupMapping = popupMapping;
    this.featureResolution = featureResolution;
    L.TileLayer.WMS.prototype.initialize.call(this, url, options);
  },
  onAdd: function (map) {
    // Triggered when the layer is added to a map.
    //   Register a click listener, then do all the upstream WMS things
    L.TileLayer.WMS.prototype.onAdd.call(this, map);
    map.on("click", this.getFeatureInfo, this);
  },
  onRemove: function (map) {
    // Triggered when the layer is removed from a map.
    //   Unregister a click listener, then do all the upstream WMS things
    L.TileLayer.WMS.prototype.onRemove.call(this, map);
    map.off("click", this.getFeatureInfo, this);
  },
  computePointsDistance: function (lat1, lng1, lat2, lng2) {
    return Math.sqrt((lng1 - lng2) ** 2 + (lat1 - lat2) ** 2);
  },
  getFeatureInfo: function (event) {
    if (this.popup !== undefined) {
      this.popup = undefined;
      return;
    }
    console.log(this.wmsParams);
    var url = this.getFeatureInfoUrl(event.latlng);
    var showResults = L.Util.bind(this.showGetFeatureInfo, this);
    // Make an AJAX request to the server and hope for the best
    // MultiLineString
    var closestCoordinates = { lat: -99999, lng: -99999 };
    const selectedLat = event.latlng.lat;
    const selectedLng = event.latlng.lng;
    var properties = undefined;

    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        switch (data.features[0].geometry.type) {
          case "Point":
            data.features.forEach((feature) => {
              const distance = this.computePointsDistance(
                selectedLat,
                selectedLng,
                feature.geometry.coordinates[1],
                feature.geometry.coordinates[0]
              );
              const closestPointDistance = this.computePointsDistance(
                selectedLat,
                selectedLng,
                closestCoordinates.lat,
                closestCoordinates.lng
              );

              if (distance < closestPointDistance) {
                closestCoordinates = {
                  lat: feature.geometry.coordinates[1],
                  lng: feature.geometry.coordinates[0],
                };
                properties = feature.properties;
              }
            });
            break;

          default:
            properties = data.features[0].properties;
            closestCoordinates = event.latlng;
            break;
        }

        if (closestCoordinates.lat !== -9999) {
          if (data.features[0].geometry.type === "MultiLineString") {
            this.CQL_FILTER = this.wmsParams.CQL_FILTER;
            delete this.wmsParams.CQL_FILTER;
            this.setParams({ featureID: properties.id });
          }
          const html = this.popupMapping(properties);
          showResults(
            null,
            closestCoordinates,
            html,
            data.features[0].geometry
          );
        }
      })
      .catch((error) => {
        console.log(error);
        showResults(error);
      });
  },
  getFeatureInfoUrl: function (latlng) {
    var filtro = `intersects(the_geom, buffer(Point(${latlng.lat} ${latlng.lng}), ${this.featureResolution}))`;
    if (
      this.wmsParams.CQL_FILTER !== undefined &&
      this.wmsParams.CQL_FILTER !== "INCLUDE"
    )
      filtro += `AND ${this.wmsParams.CQL_FILTER}`;

    var params = {
      request: "GetFeature",
      service: "WFS",
      CRS: "EPSG:4326",
      version: "2.0.0",
      CQL_FILTER: filtro,
      typeNames: this.wmsParams.layers,
      outputFormat: "application/json",
    };

    return (
      this._url.replace("wms", "wfs") +
      L.Util.getParamString(params, this._url, true)
    );
  },

  showGetFeatureInfo: function (err, latlng, content, geometry) {
    if (err) return;
    // Otherwise show the content in a popup, or something.
    this.popup = L.popup({ maxWidth: 800 })
      .setLatLng(latlng)
      .setContent(
        content +
          renderToString(
            <button
              type="button"
              className="btn btn-info btn-lg btn-block"
              id="start_simulation_button"
              style={{
                height: "20px",
                fontSize: "14px",
                paddingBottom: "21px",
                paddingTop: "1px",
                margin: "auto",
                marginTop: 6,
              }}
            >
              Run Simulation
            </button>
          )
      )
      .on("add", () => {
        document
          .getElementById("start_simulation_button")
          .addEventListener("click", () => {
            var simulationType = "single_point";
            console.log(this.wmsParams);
            if (
              this.wmsParams.layers === "res:countries" ||
              this.wmsParams.layers === "res:regions" ||
              this.wmsParams.layers === "res:districts"
            ) {
              simulationType = "multi_points";
            }
            store.dispatch({
              type: UPDATE_CREATE_PARAMS,
              payload: { key: "geometry", value: geometry },
            });
            store.dispatch({
              type: UPDATE_CREATE_PARAMS,
              payload: { key: "simulation_type", value: simulationType },
            });

            hist.push("/dashboard/cases/create");
          });
      })
      .openOn(this._map);
  },
});

export default L.tileLayer.betterWms = function (
  url,
  options,
  popupMapping,
  featureResolution
) {
  return new L.TileLayer.BetterWMS(
    url,
    options,
    popupMapping,
    featureResolution
  );
};
